module.exports = __webpack_public_path__ + "img/c1.cdf3ecd3.png";